<template>
<div class="confirm-box">
<form @submit.prevent  class="confirm-box__form confirm-form">
  <div class="confirm-form__text">
    <div v-if="act.send.success">
      Для подтверждения операции введите код из SMS
      <br /> Сообщение отправлено на номер {{ phone  }}
      <div v-if="dontsend">верный код {{right_code}}</div>
    </div>
    <p v-if="!act.send.success && act.send.message">Отправить SMS не удалось: {{act.send.message}}</p>
  </div>
  <div v-if="wait"><Dots class="confirm-box__dots"  /></div>
  <div class="confirm-form__input-box" v-if="povtorno">
    <input
      type="number"
      class="confirm-form__input"
      name="sms-code"
      :value="code"
      @input="set_code"
      :maxlength="code_max_length"
      :readonly="wait"
      required>
  </div>
  <p v-if="act.confirm.message" class="confirm-form__error-text">{{act.confirm.message}}</p>
  <!--button type="button" class="confirm-form__button" @click="confirm" :disabled="!povtorno">Подтвердить</button-->
  <button type="button" class="confirm-form__button confirm-form__button--reject" @click="cancel">Отмена</button>
  <div class="confirm-form__timer timer">
    <p v-if="povtorno" class="timer__text">
      Отправить код повторно можно будет через 
      <span>{{povtorno}} сек.</span>
    </p>
    <button v-if="!povtorno" class="timer__link" @click="send">Получить новый код</button>
  </div>
</form>
</div>
</template>

<script setup>
import Dots from '@/comp/Login/three-dots.vue'
</script>
<script>
import {sendWithdrawalSms, verifyWithdrawalSms} from '@/actions.js'

export default {
    props: ['wdr_sid', 'action', 'dontsend'],
    data: function () {
        return {
            phone: '???', // передаем объект пользователя чтобы получить телефон
            code: '',

            expires: -1,
            expires_start: -1,
            timer_leave: 0,
            timer: null,


            attempt: -1,
            ticket: '',
            operationId: '',
            right_code: null,
            act: {
                send: {
                    wait: false,
                    success: false,
                    message: '',
                },
                confirm: {
                    wait: false,
                    success: false,
                    message: '',
                }
            }
        }
    },
    mounted: function sendconf() {
        this.send()
    },
    beforeDestroy: function stoptimer() {
        this.stop_timer()
    },
    computed: {
        wait: function () {
            return this.act.send.wait || this.act.confirm.wait
        },
        povtorno: function () {
            return Math.ceil(this.timer_leave / 1000)
        },
        code_max_length: function() {
            return 4 // длина смс кода
        },
    },
    methods: {
        load_send: sendWithdrawalSms,
        load_confirm: verifyWithdrawalSms,
        start_timer: function (expires) {
            this.expires = expires
            this.expires_start = Date.now()
            this.tick_timer()
        },
        stop_timer: function () {
            this.expires_start = -1;
            if (this.timer) {
                clearTimeout(this.timer)
            }
        },
        tick_timer: function () {
            const timer_leave = this.expires_start + this.expires * 1000 - Date.now()
            if (timer_leave <= 0) {
                this.timer_leave = 0
            } else {
                this.timer_leave = timer_leave
                this.timer = setTimeout(this.tick_timer.bind(this), 1000)
            }
        },
        send: function () {
            if (this.wait) {
                return;
            }
            this.act.confirm={// обнуляем подтверждение при повторном вводе кода
                wait: false,
                success: false,
                message: ''
            }
            const act = this.act.send
            act.wait = true
            const wdr_sid = this.wdr_sid
            const dontsend = this.dontsend ? true : false
            this.load_send({wdr_sid, dontsend}).then(({ expires, attempt, ticket, phone, right_code }) => {
                act.success = true
                act.message = ''
                this.start_timer(expires)
                this.attempt = attempt
                this.ticket = ticket
                this.phone = phone // телефон не меняется, поэтому так
                this.right_code = right_code
            }, rej => {
                act.success = false
                act.message = 'string' == typeof (rej) ? rej : 'не удалось'
            }).then(() => {
                act.wait = false
            })
        },
        set_code: function (event) {
            const maxLength = this.code_max_length
            let thisValue = event.target.value

            if (thisValue.length > maxLength) {
                thisValue = thisValue.slice(0, maxLength)
            }
            this.code = thisValue;
            if (thisValue.length === maxLength) {
                this.confirm()
            }
        },
        cancel: function () {
            if (this.wait) {
                return;
            }
            this.$emit('input', false)
        },
        proc_action: function() {
            this.$emit('input', true)
        },
        confirm: function () {
            if (this.wait) {
                return
            }

            const act = this.act.confirm
            act.wait = true
            this.load_confirm({
                wdr_sid: this.wdr_sid,
                code: this.code,
                ticket: this.ticket,
            }).then(({ confirmed, expires, attempt, message, operationId }) => {
                act.success = true
                this.code = ''
                if (confirmed) {
                    act.message = ''
                    this.operationId = ''
                    this.stop_timer()
                    this.attempt = -1
                    this.ticket = ''
                    return this.proc_action() // уйдет emit
                } else {
                    this.expires = expires
                    this.attempt = attempt
                    act.message = `${message}; Попытка ${this.attempt}`
                }
            }, rej => {
                act.success = false
                act.message = 'string' == typeof (rej) ? rej : 'не удалось'
            }).then(() => {
                act.wait = false
            })
        }
    },
}
</script>

<style lang="scss">
.confirm-box {
  max-width: 410px;
  margin: 20px 0;
  background: #ededed;
  border-radius: 5px;
  padding: 10px;



  &__dots {
      height: 1.33em;
      fill: #3978ca;
  }


  &__text {
    margin: 0 0 16px;
  }

  &__form {
    margin-bottom: 30px;
  }

  &__button {
    font-family: 'Bliss', sans-serif;
    background: #f26d31;
    display: inline-block;
    color: white;
    padding: 10px 50px;
    font-size: 1.33em;
    border-radius: 3px;
    margin-top: 2em;
    cursor: pointer;
    margin: 20px auto 0;
    display: block;
    border: none;
    transition: .2s ease background;

    &:hover {
      background: #f58f61;
    }
  }
}

.confirm-form {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__button {
    font-family: 'Bliss', sans-serif;
    background: #3978ca;
    display: inline-block;
    color: white;
    padding: 8px 50px;
    font-size: 1.33em;
    border-radius: 3px;
    margin-top: 2em;
    cursor: pointer;
    margin: 20px auto 0;
    display: block;
    transition: .2s ease background, .2s ease border;
    border: 2px solid #3978ca;

    &:hover {
      background: rgb(87, 140, 209);
      border-color: rgb(87, 140, 209);
    }

    &[disabled] {
        background: #94acca;
        border: 2px solid #94acca;
    }

    &--reject {
      color: #3978ca;
      background: transparent;
      padding: 10px 50px;

      &:hover {
        background: rgba(57, 120, 202, 0.2);
      }
    }
  }

  &__input {
    width: 205px;
    border: 1px solid #e0e0e0;
    font-family: 'Bliss', sans-serif;
    font-size: 1rem;
    line-height: 1.62;
    padding: 6px 12px;
    -webkit-box-shadow: none;
    box-shadow: none;
    background-color: #fff;
    border-radius: 5px;
    margin: 5px 0;
    color: #555555;
    transition: .25s ease box-shadow;
    text-align: center;
    letter-spacing: 14px;
    font-size: 20px;
    padding: 5px 0;
    -moz-appearance: textfield;

    &:hover,
    &:focus, &:focus-visible {
      box-shadow: 0 0px 0px 2px #565656;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__error-text {
    color: #BE020D;
    margin: 0;
  }

  &__timer {
    margin-top: 10px;
  }

}

.timer {
  text-align: center;

  &__text {
    margin: 0 0 .625rem;
  }

  &__link {
    color: #0056bc;
    text-decoration: none;
    cursor: pointer;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    background: none;
    border: none;

    &:hover {
      color: #000;
    }
  }
}
</style>
